import { useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { useGetClienteByIdMutation, useGetClienteRutasMutation } from '../../../../store/api/endpoints/clientesApiSlice'

import { openFeedback } from '../../../../store/slices/feedback'
import { getUsuarioPermisos } from '../../../../store/slices/auth'

import Loading from '../../../elementos/Loading'
import HeaderVista from '../../../elementos/HeaderVista'
import TituloMini from '../../../elementos/TituloMini'
import Card from '../../../elementos/Card'

import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
// Cambiamos Grid por Grid2 (MUI v6)
import { Container, Grid2 as Grid } from '@mui/material'

import PeopleAltIcon from '@mui/icons-material/PeopleAlt'

export default function ClienteRutasIndex() {
    const { id } = useParams() // Desestructuración limpia
    const dispatch = useDispatch()
    const permisosDelUsuario = useSelector(getUsuarioPermisos)

    const [
        getCliente,
        {
            data: responseGetCliente,
            isUninitialized: isUninitializedGetCliente,
            isLoading: isLoadingGetCliente,
            isError: isErrorGetCliente,
            error: errorDataGetCliente,
        }
    ] = useGetClienteByIdMutation()

    const [
        getRegistro,
        {
            data: responseGetRegistro,
            isUninitialized: isUninitializedGetRegistro,
            isLoading: isLoadingGetRegistro,
            isError: isErrorGetRegistro,
            error: errorDataGetRegistro,
        }
    ] = useGetClienteRutasMutation()

    useEffect(() => {
        getCliente(id)
        getRegistro(id)
    }, [id, getCliente, getRegistro]) // Dependencias añadidas para buenas prácticas

    useEffect(() => {
        if (isErrorGetCliente) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataGetCliente?.data?.message || 'Error al cargar cliente'
            }))
        }
    }, [isErrorGetCliente, errorDataGetCliente, dispatch])

    useEffect(() => {
        if (isErrorGetRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataGetRegistro?.data?.message || 'Error al cargar rutas'
            }))
        }
    }, [isErrorGetRegistro, errorDataGetRegistro, dispatch])

    if (!permisosDelUsuario.includes(3)) {
        return <Typography sx={{ p: 3 }}>No tienes acceso a visualizar los clientes.</Typography>
    }

    if (isUninitializedGetCliente || isLoadingGetCliente || isUninitializedGetRegistro || isLoadingGetRegistro) {
        return <Loading />
    }

    // Helper para no repetir lógica de delete/edit en las Cards
    const getCardProps = (tipo, label, desc, imgProp) => {
        const tieneImagen = !!responseGetRegistro[imgProp]; // Evalúa si existe y no es string vacío

        return {
            titulo: label,
            img: responseGetRegistro[imgProp],
            descripcion: desc,
            // Si no tiene imagen, mandamos undefined para que el componente Card sepa que NO debe mostrar nada
            confirmDelete: tieneImagen
                ? {
                    httpDelete: `/clientes/${id}/edit/rutas/${tipo}/remove`,
                    returnUrl: `/clientes/${id}/edit/rutas`
                }
                : undefined,
            rutaPencil: !tieneImagen
                ? `/clientes/${id}/edit/rutas/${tipo}`
                : undefined
        };
    };

    return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link style={{ textDecoration: 'none', color: 'inherit' }} to="/clientes">
                            Clientes
                        </Link>
                        <Link style={{ textDecoration: 'none', color: 'inherit' }} to={`/clientes/${id}`}>
                            {responseGetCliente?.dominio}
                        </Link>
                        <Typography color="text.primary">Editar Imágenes</Typography>
                    </Breadcrumbs>
                }
                icon={<PeopleAltIcon />}
            />

            <Container className="vistaFormulario formulario" component="main" maxWidth="lg" sx={{ mt: 3 }}>
                <Grid container spacing={3}>
                    <Grid size={12}>
                        <TituloMini titulo="Archivos e Imágenes">
                            Estos archivos conforman la vista de clientes.
                        </TituloMini>
                    </Grid>

                    {/* Fila de Cards usando Grid2 size */}
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Card {...getCardProps('logo', 'Logo', 'Es el logo de la marca. Aparecerá en la vista de cliente.', 'logo')} />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <Card {...getCardProps('socials', 'Socials', 'Imagen para compartir en redes sociales (WhatsApp, FB, etc).', 'socials')} />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <Card {...getCardProps('favicon', 'Favicon', 'Icono que aparece en la pestaña del navegador.', 'favicon')} />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <Card {...getCardProps('banner1', 'Banner 1', 'Imagen de portada (antes del listado de servicios).', 'banner1')} />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <Card {...getCardProps('banner2', 'Banner 2', 'Imagen de portada (después del listado de servicios).', 'banner2')} />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <Card
                            titulo="CSS"
                            descripcion="Archivo de estilos para personalizar la vista. Casi no se utiliza."
                            confirmDelete={responseGetRegistro.css !== '' ? { httpDelete: `/clientes/${id}/edit/rutas/css/remove`, returnUrl: `/clientes/${id}/edit/rutas` } : ''}
                            rutaPencil={responseGetRegistro.css === '' ? `/clientes/${id}/edit/rutas/css` : ''}
                        />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}